/* ===========================================================================
   Pastilles de couleur des cartes produit — apercu au survol.

   Chaque <li> porte data-daz-apercu : l URL de la PREMIERE photo de sa couleur
   (voir snippets/product-card.liquid). Survoler une pastille remplace la
   vignette de la carte par cette photo ; on rend l originale en sortant.

   Le srcset doit etre vide pendant l apercu : le navigateur le prefere au src,
   et l ancienne image reviendrait au premier recalcul de mise en page.

   La classe daz-apercu neutralise l image de presentation, qui autrement
   passerait par-dessus l apercu — la carte est survolee elle aussi.
   =========================================================================== */
(function () {
  var ORIG = 'dazOrigine';

  function vignette(carte) {
    return carte.querySelector('.product-card__media a.media img:not(.product-card__prez)');
  }

  /* L anneau de la couleur affichee suit l apercu : pendant le survol il
     designe la pastille survolee, puisque c est sa photo qui est montree.
     La pastille d origine est marquee pour qu on sache ou revenir. */
  function deplacerAnneau(carte, li) {
    var actuel = carte.querySelector('.color-swatch.is-active');
    if (actuel && !carte.querySelector('.daz-actif-origine')) actuel.classList.add('daz-actif-origine');
    Array.prototype.forEach.call(carte.querySelectorAll('.color-swatch.is-active'), function (e) {
      e.classList.remove('is-active');
    });
    var sw = li.querySelector('.color-swatch');
    if (sw) sw.classList.add('is-active');
  }

  function rendreAnneau(carte) {
    var origine = carte.querySelector('.daz-actif-origine');
    if (!origine) return;
    Array.prototype.forEach.call(carte.querySelectorAll('.color-swatch.is-active'), function (e) {
      e.classList.remove('is-active');
    });
    origine.classList.add('is-active');
    origine.classList.remove('daz-actif-origine');
  }

  function montrer(carte, url) {
    var img = vignette(carte);
    if (!img || !url) return;
    if (!img.dataset[ORIG]) {
      img.dataset[ORIG] = JSON.stringify({ src: img.getAttribute('src'), srcset: img.getAttribute('srcset') || '' });
    }
    if (img.getAttribute('src') === url) return;
    img.setAttribute('srcset', '');
    img.setAttribute('src', url);
    carte.classList.add('daz-apercu');
  }

  function rendre(carte) {
    var img = vignette(carte);
    if (!img || !img.dataset[ORIG]) return;
    var o = JSON.parse(img.dataset[ORIG]);
    img.setAttribute('src', o.src);
    if (o.srcset) img.setAttribute('srcset', o.srcset);
    delete img.dataset[ORIG];
    carte.classList.remove('daz-apercu');
  }

  document.addEventListener('pointerover', function (e) {
    var cible = e.target.closest ? e.target.closest('[data-daz-apercu]') : null;
    if (!cible) return;
    var carte = cible.closest('.product-card');
    if (!carte) return;
    montrer(carte, cible.getAttribute('data-daz-apercu'));
    deplacerAnneau(carte, cible);
  });

  /* On rend l image quand la souris quitte la LISTE, pas la pastille : passer
     d une pastille a sa voisine ne doit pas faire clignoter la vignette. */
  document.addEventListener('pointerout', function (e) {
    var liste = e.target.closest ? e.target.closest('.product-card__bottom') : null;
    if (!liste) return;
    if (e.relatedTarget && liste.contains(e.relatedTarget)) return;
    var carte = liste.closest('.product-card');
    if (!carte) return;
    rendre(carte);
    rendreAnneau(carte);
  });
})();
